<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <profileHeader v-if="$store.state.user != '' && !pageLoading" />
    <div
      v-if="$store.state.user != ''"
      class="mt-1 container"
      style="font-size: 15px"
    >
      <div class="text-center mt-15" v-if="pageLoading">
        <v-progress-circular
          :size="70"
          :width="2"
          color="#023679"
          indeterminate
        ></v-progress-circular>
      </div>

      <div id="homePage" class="pr-1 pt-4" v-if="!pageLoading">
        <div style="margin-top: 0px">
          <h4 class="text-center white--text pb-3">
            {{
              $store.state.language == "English"
                ? `You have invited ${allEmployers.length} ${
                    allEmployers.length == 1 ? " Employer" : " Employers"
                  }`
                : `${allEmployers.length} ${
                    allEmployers.length == 1 ? " አሰሪ" : " አሰሪዎችን "
                  } ጋብዘዋል`
            }}
          </h4>
          <br />

          <v-layout row wrap class="white--text">
            <v-flex
              xs12
              class="text-center mr-7 ml-7 pa-4"
              style="
                border: 1px solid;
                border-color: #383838;
                border-radius: 5px;
              "
            >
              <span>
                {{
                  $store.state.language == "English"
                    ? "Total Posts"
                    : "ጠቅላላ ልጥፎች"
                }}
                = {{ totalPosts }}</span
              >
              <br />
              <span>
                {{
                  $store.state.language == "English"
                    ? "Total Balance"
                    : "ጠቅላላ ክፍያ"
                }}
                = {{ totalPosts * referralMultiplayer }}</span
              >
              <br />
              <br />

              <v-btn
                text
                small
                class="white--text mr-6"
                style="
                  text-transform: none !important;
                  background-color: #023679;
                "
              >
                <span>See details</span>
              </v-btn>
              <v-btn
                text
                small
                class="white--text"
                style="text-transform: none !important; background-color: green"
              >
                <span>Withdraw</span>
              </v-btn>
            </v-flex>

            <v-flex xs12 class="mt-2 mb-2 mt-15 pt-7 text-center">
              <p>
                {{
                  $store.state.language == "English"
                    ? "Get attractive rewards by inviting an employer."
                    : "አሰሪ በመጋበዝ ማራኪ ሽልማቶችን ያግኙ።"
                }}
              </p>
              <div class="text-center">
                <v-btn
                  id="'zoomme"
                  :class="{ zoom: isZoomed }"
                  class="pl-8 pr-8 pt-6 pb-6 white--text"
                  text
                  style="
                    background-color: #023679;
                    border-radius: 10px;
                    font-size: 16px;
                    text-transform: none !important;
                    font-weight: bold;
                  "
                  @click="inviteEmployer"
                >
                  {{
                    $store.state.language == "English"
                      ? "Invite an employer"
                      : "ቀጣሪ ይጋብዙ"
                  }}
                  <v-icon
                    style="font-size: 17px"
                    class="grey--text text--lighten-1 ml-1"
                    >person_add_alt1</v-icon
                  >
                </v-btn>

                <v-btn
                  class="ml-2 pt-6 pb-6 white--text"
                  text
                  style="
                    background-color: #023679;
                    border-radius: 10px;
                    font-size: 18px;
                    text-transform: none !important;
                  "
                  @click="copyReferral"
                >
                  <v-icon class="white--text">content_copy</v-icon>
                </v-btn>
              </div>

              <p
                class="green--text mt-5 text-right pr-15"
                v-if="referralCopyMessage != ''"
              >
                {{ referralCopyMessage }}
              </p>
            </v-flex>
          </v-layout>
        </div>

        <AlertDialog
          :message="alertMessage"
          :show="showAlertDialog"
          @close="showAlertDialog = false"
        />
        <ConfirmDialog
          :message="confirmMessage"
          :show="showConfirmDialog"
          @confirm="handleConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import profileHeader from "./profileHeader.vue";
import AlertDialog from "./AlertDialog.vue";
import ConfirmDialog from "./ConfirmDialog.vue";

export default {
  components: {
    profileHeader,

    AlertDialog,
    ConfirmDialog,
  },
  data: () => ({
    pageLoading: false,
    allEmployers: [],
    detailDialog: false,
    selectedDetail: "",

    showAlertDialog: false,
    alertMessage: "",
    showConfirmDialog: false,
    confirmMessage: "",
    confirmResult: null,
    postData: "",
    indexPost: -1,
    whichToCall: "",

    referralMultiplayer: 10,
    totalPosts: 0,
    isZoomed: false,
    zoomInterval: null,
    empUrl: "",
    referralCopyMessage: "",
  }),

  beforeDestroy() {
    // Clear the interval before the component is destroyed
    if (this.zoomInterval) {
      clearInterval(this.zoomInterval);
    }
  },

  methods: {
    copyReferral() {
      navigator.clipboard.writeText(this.empUrl).then(() => {
        this.referralCopyMessage =
          this.$store.state.language == "English" ? "Text copied" : "ጽሑፍ ተቀድቷል";

        setTimeout(() => {
          this.referralCopyMessage = "";
        }, 3000);
      });
    },
    inviteEmployer() {
      const url = this.empUrl;
      const text =
        "Post your vacancy on Addis Ababa Jobs and connect with talented candidates! | ክፍት የስራ ቦታዎን በአዲስ አበባ ስራዎች መተግበርያ ላይ ይለጥፉ እና ጎበዝ ከሆኑ እጩ ሰራተኞች ጋር ይገናኙ!";
      // Opens the Telegram interface where the user can select friends or groups to share
      window.open(
        `https://t.me/share/url?url=${encodeURIComponent(
          url
        )}&text=${encodeURIComponent(text)}`,
        "_blank"
      );
    },
    startZoom() {
      this.isZoomed = true;
      this.zoomInterval = setInterval(() => {
        this.isZoomed = !this.isZoomed;
      }, 500); // Set interval for slower toggling
    },
    stopZoom() {
      this.isZoomed = false;
      clearInterval(this.zoomInterval);
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    showAlert(message) {
      this.alertMessage = message;
      this.showAlertDialog = true;
    },
    showConfirm(message) {
      this.confirmMessage = message;
      this.showConfirmDialog = true;
    },
    handleConfirm(answer) {
      this.confirmResult = answer;

      this.showConfirmDialog = false;
      if (answer == true) {
        if (this.whichToCall == "approve") {
          this.approveJob(this.postData, this.indexPost);
        } else if (this.whichToCall == "reject") {
          this.rejectJob(this.postData);
        } else if (this.whichToCall == "delete") {
          this.deletePost(this.postData);
        }
      } else {
        this.postData = "";
        this.indexPost = -1;
      }
    },

    async getReferrals() {
      this.pageLoading = true;
      try {
        var result = await axios({
          method: "POST",
          url: this.$store.state.userURL,

          data: {
            query: `{
            getReferredEmployers(tg_id:"${this.$store.state.user.tg_id}"){
                      user_id
                      tg_id  
                      tg_username   

                  getJobs{
                    post_id
                   tg_id
                   title                    
                    company_address    
                  company_name
                   bank_slip
                            
                  }
    
    
               }
          }
          `,
          },
        });

        this.allEmployers = result.data.data.getReferredEmployers;
        this.totalPosts = 0;
        for (let i = 0; i < this.allEmployers.length; i++) {
          this.totalPosts =
            this.totalPosts + this.allEmployers[0].getJobs.length;
        }
      } catch (err) {
        this.showAlert(
          this.$store.state.language == "English"
            ? err.message
            : "የኢንተርኔት ችግር አለ፣ እባክዎ እንደገና ይሞክሩ"
        );
      }
      this.pageLoading = false;
    },

    formatDate(dateString) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // Create a new Date object from the date string
      const date = new Date(dateString);

      // Ensure the date is valid
      if (isNaN(date.getTime())) {
        throw new Error("Invalid date format");
      }

      // Extract the month, day, and year
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();

      // Format the day with a suffix
      let suffix = "th";
      if (day % 10 === 1 && day !== 11) {
        suffix = "st";
      } else if (day % 10 === 2 && day !== 12) {
        suffix = "nd";
      } else if (day % 10 === 3 && day !== 13) {
        suffix = "rd";
      }

      // Return the formatted date string
      return `${month} ${day}${suffix}, ${year}`;
    },
  },
  async created() {
    if (this.$store.state.user != "") {
      this.empUrl = `https://t.me/addis_ababa_jobs_bot/addisababajobs?startapp=ref_${this.$store.state.user.tg_id}`;
      await this.getReferrals();
      this.startZoom();
    }
  },
};
</script>
<style scoped>
#homePage {
  max-width: 800px;
  margin: auto;
  line-height: 1.5;
}

input {
  width: 100%;
  color: white;
}

input::placeholder {
  color: white;
  opacity: 1;
}

textarea {
  width: 100%;
  color: white;
}

textarea::placeholder {
  color: white;
  opacity: 1;
}

#imageCamera {
  background-color: #272a2f;
  font-size: 16px;
}

.v-radio .v-icon {
  color: red !important;
}
#zoomme {
  transition: transform 0.5s ease-in-out; /* Smooth transition */
  will-change: transform; /* Hint for smoother animations */
}
.zoom {
  transform: scale(1.035); /* Slightly less scaling for a more subtle effect */
}
.truncate-text {
  display: -webkit-box; /* Necessary for -webkit-line-clamp to work */
  -webkit-box-orient: vertical; /* Specifies the box orientation */
  -webkit-line-clamp: 2; /* Limits the text to 2 lines */
  overflow: hidden; /* Hides the overflow text */
  text-overflow: ellipsis; /* Adds ellipsis (...) after the truncated text */
  max-height: 3em; /* Adjust based on the line height */
  line-height: 1.5em; /* Adjust the line height */
}
</style>
